import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row, Button, Tooltip, Form } from "reactstrap";
import { useNavigate, Link } from 'react-router-dom';
import * as Yup from "yup";
import { useFormik } from "formik";
import { postOnCallPolicy as onPostOnCallPolicy, getOncallEligibleUsers as onGetOncallEligibleUsers } from "../../store/onCallPolicy/actions";
import RotationPolicyRow from './RotationPolicyRow';
import Switch from "react-switch";
import './styles.scss';
import { getUserColor } from "../../helpers/component_helpers";
import Select from "react-select";
import timeZoneOptions from "./TimeZone"
import {showNotification} from "../../components/Common/notification";

const CreatePolicy = () => {
    document.title = "Create Policies | Temperstack";
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [policyName, setPolicyName] = useState('');
    const [startDate, setStartDate] = useState(new Date().toISOString().substr(0, 10));
    const [toggle, setToggle] = useState(true);
    const [rotationalPolicies, setRotationalPolicies] = useState([]);
    const [timeZone, setTimeZone] = useState('');
    const users = useSelector((state) => state.onCallPolicy.oncall_eligible_users || []);

    const availableUsers = users?.map((user) => ({
        id: user.id,
        name: user.name,
        color: getUserColor(user.id),
    }));

    const policyNameValidationSchema = Yup.string().required("Please enter a policy name");

    useEffect(() => {
        dispatch(onGetOncallEligibleUsers());
    }, [onGetOncallEligibleUsers]);

    const addRotationPolicy = () => {
        const defaultEscalationTime = rotationalPolicies?.length * 10;
        const newPolicy = {
            rotation_start_date: "",
            escalation_time: defaultEscalationTime,
            rotation_frequency: "Weekly",
            rotation_users: [],
        };
        setRotationalPolicies([...rotationalPolicies, newPolicy]);
    };

    const removeRotationPolicy = (indexToRemove) => {
        const updatedPolicies = [...rotationalPolicies];
        updatedPolicies.splice(indexToRemove, 1);
        setRotationalPolicies(updatedPolicies);
    };

    const handleChange = (index, field, value) => {
        const updatedPolicies = [...rotationalPolicies];
        if (field === 'escalation_time') {
            updatedPolicies[index][field] = parseInt(value, 10);
        } else {
            updatedPolicies[index][field] = value;
        }
        setRotationalPolicies(updatedPolicies);
    };

    const addUserToPolicy = (index, userId) => {
        const updatedPolicies = [...rotationalPolicies];
        const user = availableUsers?.find((user) => user.id === userId);
        updatedPolicies[index].rotation_users = [...updatedPolicies[index].rotation_users, user.id];
        setRotationalPolicies(updatedPolicies);
    };

    const removeUserFromPolicy = (index, userIndexToRemove) => {
        const updatedPolicies = [...rotationalPolicies];
        updatedPolicies[index].rotation_users.splice(userIndexToRemove, 1);
        setRotationalPolicies(updatedPolicies);
    };

    const validateShiftTimeDifferenceAndDuration = (rotationalPolicies) => {
        return rotationalPolicies
            .filter(policy => policy.rotation_frequency === 'Custom')
            .some(policy => {
                const startTimeInMinutes = parseInt(policy.shift_start_time_hours) * 60 + parseInt(policy.shift_start_time_minutes);
                const endTimeInMinutes = parseInt(policy.shift_end_time_hours) * 60 + parseInt(policy.shift_end_time_minutes);
                const shiftDurationInMinutes = parseInt(policy.shift_duration_hours) * 60 + parseInt(policy.shift_duration_minutes);
                if (isNaN(startTimeInMinutes) || isNaN(endTimeInMinutes) || isNaN(shiftDurationInMinutes)) {
                    return true;
                }
            });
    };

    const validateRotationTimes = (rotationalPolicies) => {
        return rotationalPolicies
            .filter(policy => policy.rotation_frequency === 'Custom')
            .some(policy =>
                (policy.shift_start_time_hours === null && policy.shift_start_time_minutes === null) ||
                (policy.shift_end_time_hours === null && policy.shift_end_time_minutes === null) ||
                (typeof(policy.shift_start_time_hours) === 'undefined' && typeof(policy.shift_start_time_minutes) === 'undefined') ||
                (typeof(policy.shift_end_time_hours) === 'undefined' && typeof (policy.shift_end_time_minutes) === 'undefined')||
                (policy.shift_duration_hours === null && policy.shift_duration_minutes === null) ||
                (typeof(policy.shift_duration_hours) === 'undefined' && typeof(policy.shift_duration_minutes) === 'undefined')
            );
    }

    const handleSubmit = () => {
        if (validation.isValid) {
            if (rotationalPolicies.length === 0) {
                showNotification("error", "You need at least one rotation");
                return;
            }
            const hasEmptyRotationUsers = rotationalPolicies.some(policy => !policy.rotation_users || policy.rotation_users.length === 0);

            if (hasEmptyRotationUsers) {
                showNotification("error", "Each policy must have at least one rotation user");
                return;
            }
            const hasEmptyRotationDates = validateRotationTimes(rotationalPolicies);
            if (hasEmptyRotationDates) {
                showNotification("error", "Custom rotation schedules must have a start time ,end time and shift duration.");
                return;
            }
            // const hasInvalidShiftTimeDifferenceOrDuration = validateShiftTimeDifferenceAndDuration(rotationalPolicies);
            // if (hasInvalidShiftTimeDifferenceOrDuration) {
            //     showNotification("error", "Start time must be before end time, and shift duration cannot exceed the available time.");
            //     return;
            // }
            const policiesWithUpdatedStartDate = rotationalPolicies?.map((policy) => ({
                ...policy,
                rotation_start_date: startDate,
            }));
            try {
                dispatch(onPostOnCallPolicy(validation.values.policyName, timeZone,toggle, policiesWithUpdatedStartDate));
                localStorage.setItem("state_of_add_toast", "true");
                // setTimeout(() => {
                //     navigate('/oncall-policies');
                // }, 1000);
            } catch (error) {
                console.error('Error:', error);
            }
        }
    };

    const validation = useFormik({
        initialValues: {
            policyName: '',
            timezone: '',
        },
        validationSchema: Yup.object({
            policyName: policyNameValidationSchema,
        }),
        onSubmit: handleSubmit,
    });

    const Offsymbol = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    fontSize: 12,
                    color: "#fff",
                    paddingRight: 1
                }}
            >
                {" "}
                No
            </div>
        );
    };

    const OnSymbol = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    fontSize: 12,
                    color: "#fff",
                    paddingRight: 1
                }}
            >
                {" "}
                Yes
            </div>
        );
    };

    const [tooltipRepeat, setToolTipRepeat] = useState(false);

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#382b42', // Background color of the control (react-select)
            borderRadius: 0,
            color: "white",
            position:"relative",
            borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
        }),
        option: (provided, state) => ({
            ...provided,
            position:"relative",
            backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
            color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
        }),
        menu: (provided) => ({
            ...provided,
            position:"relative",
            background: '#382b42', // Background color of the dropdown menu
        }),
        singleValue: (provided) => ({
            ...provided,
            position:"relative",
            color: '#ffffff', // Color of the selected value
        }),
    };

    useEffect(() => {
        const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setTimeZone(localTimeZone);
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form onSubmit={validation.handleSubmit}>
                        <Row>
                            <Col lg="9">
                                <h3>Create Policy</h3>
                            </Col>
                        </Row>
                        <Row className="mt-2 mb-4 border-dark">
                            <Col lg="4" className="mt-2 mb-2">
                                <div className="d-flex flex-row">
                                    <h4 className="col-form-label text-right w-25">
                                        Policy Name
                                    </h4>
                                    <div className="w-75 d-flex justify-content-end">
                                        <input
                                            className={`input ${validation.errors.policyName ? "is-invalid" : ""}`}
                                            type="text"
                                            placeholder="Add on-call policy name"
                                            value={validation.values.policyName}
                                            onChange={validation.handleChange}
                                            name="policyName"
                                            style={{ width: "100%" ,textAlign:"start"}}
                                        />
                                        {validation.errors.policyName && (
                                            <div className="invalid-feedback">{validation.errors.policyName}</div>
                                        )}
                                    </div>
                                </div>
                            </Col>
                            <Col lg='3' className='mt-2 mb-2'>
                                <div className="d-flex align-items-center col-md-12">
                                    <h4 className="col-form-label me-3">
                                        Time Zone
                                    </h4>
                                    <div className="flex-grow-1">
                                        <Select
                                            className="select2-selection"
                                            value={timeZoneOptions.find(option => option.code === timeZone)}
                                            options={timeZoneOptions}
                                            onChange={(selectedOption) => setTimeZone(selectedOption.code)}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    neutral0: '#222736',
                                                    neutral5: '#485EC4',
                                                    neutral10: '#485EC4',
                                                    neutral60: '#ffffff',
                                                    neutral70: '#ffffff',
                                                    neutral80: '#ffffff',
                                                    neutral90: '#ffffff',
                                                    primary: '#485EC4',
                                                },
                                            })}
                                            styles={customStyles}
                                            maxMenuHeight={100}
                                            maxMenuWidth={100}
                                            menuPortalTarget={document.body}
                                        >
                                        </Select>
                                    </div>
                                </div>
                            </Col>
                            <Col lg="5" className="mt-2">
                                <div className='d-flex flex-row'>
                                    <div  style={{width:'60%'}} className='d-flex flex-row'>
                                        <h4 className="col-md-12 col-form-label text-right w-25">
                                            Start Date
                                        </h4>
                                        <div className="w-75 d-flex justify-content-start">
                                            <input
                                                readOnly
                                                className="input text-right w-75"
                                                type="date"
                                                id="date-input"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div style={{width:"40%"}} className='d-flex flex-row'>
                                        <h5 className="col-md-12 w-50 col-form-label text-right">
                                            Repeat
                                            <span
                                                id="TooltipRepeat"
                                                onMouseOver={() => setToolTipRepeat(true)}
                                                onMouseLeave={() => setToolTipRepeat(false)}
                                                className="alert-icon">
                                        <i className="mdi mdi-information-outline text-warning"/>
                                        </span>
                                            <Tooltip
                                                placement="right"
                                                isOpen={tooltipRepeat}
                                                target="TooltipRepeat"
                                                toggle={() => {
                                                    setToolTipRepeat(!tooltipRepeat);
                                                }}
                                                style={{
                                                    border: "2px solid #f1b44c",
                                                    borderRadius: "10px",
                                                    backgroundColor: "#2a3042",
                                                    zIndex: 1
                                                }}
                                            >
                                                Repeat the escalation schedule after the last user in the rotation has
                                                been reached.
                                            </Tooltip>
                                        </h5>
                                        <Switch
                                            uncheckedIcon={<Offsymbol/>}
                                            checkedIcon={<OnSymbol/>}
                                            className="mb-sm-8 mt-2 mb-2 justify-content-start"
                                            onColor="#626ed4"
                                            onChange={() => {
                                                setToggle(!toggle);
                                            }}
                                            checked={toggle}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            {rotationalPolicies?.map((policy, index) => (
                                <RotationPolicyRow
                                    key={index}
                                    policy={policy}
                                    index={index}
                                    onChange={handleChange}
                                    onRemove={() => removeRotationPolicy(index)}
                                    availableUsers={availableUsers}
                                    addUser={addUserToPolicy}
                                    removeUser={removeUserFromPolicy}
                                />
                            ))}
                        </Row>
                        <Row className="mb-4">
                            <Col lg="10">
                                <Button
                                    color="primary"
                                    className="large-button mt-1"
                                    onClick={addRotationPolicy}
                                >
                                    <i className="mdi mdi-plus me-1"/>
                                    Add Rotation
                                </Button>
                            </Col>
                            <Col lg="1">
                                <Button
                                    color="primary"
                                    className="btn btn-primary waves-effect waves-light large-button mt-1"
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            </Col>
                            <Col lg="1">
                                <Link to="/oncall-policies">
                                    <Button
                                        color="primary"
                                        className="btn btn-danger waves-effect waves-light large-button mt-1"
                                    >
                                        Cancel
                                    </Button>
                                </Link>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        </React.Fragment >
    );
};

export default CreatePolicy;